import { action } from 'satcheljs';
import { ActionSource, addDatapointConfig } from 'owa-analytics-actions';
import { CalendarNavigationMode } from 'fabric-calendar';

/**
 * Action to toggle the navigation mode and update the events count map
 */
export const toggleNavigationMode = action(
    'toggleNavigationMode',
    (newMode: CalendarNavigationMode, source: string) =>
        addDatapointConfig(
            {
                name: 'DatePickerNavModeChanged',
                actionSource: source as ActionSource,
                customData: {
                    isUIAction: true,
                    newMode: newMode,
                },
            },
            { newMode }
        )
);
